
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapState } from 'vuex';
    import {VAutocomplete, VDatePickerInput, VTextField} from '@/types/Components';
    import DatePickerInput from '@/components/DatePickerInput.vue';
    import {ValidationRules} from '@/store/types';

    @Component({
        components: {
            DatePickerInput,
        },
        computed: {
            ...mapState('globals', ['rules', 'titelauswahl', 'formatDate', 'parseDate']),
            ...mapGetters('authentication', ['impfstelleDetail']),
            ...mapState('statistik', ['loaders', 'verrechnungen']),
            ...mapState('globals', ['sortDate']),
            ...mapState('patient', ['patientData']),
        },
        methods: {
            ...mapActions('statistik', ['printEinsendeformular']),
            ...mapActions('session', ['setSelectedVerrechnung']),
            ...mapActions('patient', ['loadPatient']),
        },
    })
    export default class Einsendeformular extends Vue {
        @Prop() visible!: boolean;

        public $refs!: {
            svnrLaufnummer: VTextField;
            svnrGeburtsdatum: VTextField;
            geburtsdatum: VTextField;
            geburtsdatumField: VDatePickerInput;

        };

        public data = {
            titel: ' ',
            nachname: ' ',
            vorname: ' ',
            geburtsdatum: ' ',
            svnr: ' ',
            geschlecht: ' ',
            bezahlt: ' ',
            privat: ' ',
            einsender: ' ',
        };

        public printEinsendeformular!: (payload: any) => void;
        public patientData:any;
        public svnrLaufnummer = '';
        public svnrGeburtsdatum = '';
        public svnrErrorMessages: string[] = [];
        public rules!: ValidationRules;
        public formatDate!: (input: string | null) => string | null;
        public parseDate!: (input: string | null) => string | null;

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.data.bezahlt = '';
                this.data.privat = '';
                this.data.einsender = '';
                this.svnrLaufnummer = '';
                this.svnrGeburtsdatum = '';
            }
        }

        public onInputSvnrLaufnummer(value: string): void {
            if (!this.$refs.svnrGeburtsdatum) {
                return;
            }

            if (value.length === 10) {
                this.svnrGeburtsdatum = value.slice(4);
                this.$refs.svnrGeburtsdatum.focus();
            } else if (value.length === 5 &&
                (this.$refs.svnrLaufnummer.$refs.input as HTMLInputElement).selectionStart === 5) {
                this.svnrGeburtsdatum = value.slice(4);
                this.$refs.svnrGeburtsdatum.focus();
            }
        }

        public validateSvnr(): void {
            this.svnrErrorMessages = [];

            if (this.$refs.svnrLaufnummer?.isFocused ?? true) return;
            if (this.$refs.svnrGeburtsdatum?.isFocused ?? true) return;

            const rules = [
                this.rules.required,
                this.rules.exactDigits(10),
            ];

            for (const rule of rules) {
                const valid = rule(this.svnr);
                if (valid !== true) {
                    this.svnrErrorMessages.push(valid as string);
                }
            }

            this.data.svnr = this.svnr;
        }

        public get svnr(): string {
            return this.svnrLaufnummer + this.svnrGeburtsdatum;
        }

        public onClickPrint(data:any) {
            data.titel = this.patientData.titel;
            data.vorname = this.patientData.vorname;
            data.nachname = this.patientData.nachname;
            data.geschlecht = this.patientData.geschlecht;
            data.geburtsdatum = this.patientData.geburtsdatum;
            data.svnr = this.patientData.svnr;
            if (data.einsender.length < 1) {
                data.einsender = this.patientData.strasse + '\n' + this.patientData.plz + ' ' + this.patientData.ort;
            }
            this.printEinsendeformular(data);
        }
    }
